export const catalogsKeys = {
    models: () => ['models']
};
//# sourceMappingURL=catalogs.keys.js.map